import { MainContainer } from './interface/Container';
import { Header } from './interface/Header'
import { Footer } from './interface/Footer'

function App() {
  return (
    <>
      <Header />
      <MainContainer/>
      <Footer />
    </>
  );
}

export default App;
